export default function KeenSliderDots({
  sliderInstance,
  activeSlide,
}: {
  sliderInstance: MutableRefObject<KeenSliderInstance<object, object, KeenSliderHooks>>
  activeSlide: number
}) {
  if (!sliderInstance.current) {
    return null
  }

  const activeSlideEl = sliderInstance.current.slides[activeSlide]
  const isLightMode = activeSlideEl?.querySelector('.theme--gradient-light') !== null

  // console.log('Is light mode:', isLightMode)

  const sliderDisabled = sliderInstance.current.options.disabled

  return (
    <div
      className="keen-slider__dots flex gap-xxs"
      data-theme={isLightMode ? 'light' : 'dark'}
      {...(sliderDisabled ? { 'data-keen-slider-disabled': '' } : {})}>
      {sliderInstance.current.slides.map((slide, index) => {
        const isActive = activeSlide === index

        const shadow = 'shadow-[0px_2px_4px_-1px_rgba(0,0,0,0.1),_0_0_14px_0px_rgba(0,0,0,0.25)]'

        return (
          <button
            key={index}
            className={`h-[4px] w-[40px] flex-shrink bg-[currentColor] transition-all duration-200 ease-in-out ${shadow} ${isActive ? 'opacity-100' : 'opacity-25'}`}
            aria-label={`Go to slide ${index}`}
            aria-current={isActive ? 'true' : 'false'}
            onClick={() => {
              sliderInstance.current?.moveToIdx(index)
            }}></button>
        )
      })}
    </div>
  )
}
